// Supabase client (V3 scaffold).
// Graceful degradation: when env vars are absent the app runs exactly as before —
// no auth, no cloud sync, free tools open, lessons in localStorage only.
// Real keys land via .env (see .env.example).

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** True only when both env vars are present — gates all auth/cloud features. */
export const isSupabaseConfigured = Boolean(url && anonKey);

// Single shared client, created lazily and only when configured.
let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (!isSupabaseConfigured) return null;
  if (!client) {
    client = createClient(url as string, anonKey as string, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}
